import React from "react";
import PageHeader from "../components/PageHeader";
import { useDashboardStats, useLeads, useTeam } from "../../hooks/useFirebase";

const ReportsPage = () => {
  const { stats } = useDashboardStats();
  const { leads } = useLeads();
  const { teamMembers } = useTeam();

  const conversionRate = stats && stats.totalLeads > 0
    ? ((stats.convertedLeads / stats.totalLeads) * 100).toFixed(1)
    : "0.0";

  return (
    <div>
      <PageHeader title="Reports & Analytics" breadcrumbs={["Admin", "Reports"]} />

      {/* Key Metrics */}
      <div className="admin-grid admin-grid-4" style={{ marginTop: 24, marginBottom: 24 }}>
        {[
          { label: "Conversion Rate", value: `${conversionRate}%`, icon: "📈", cls: "qs-blue" },
          { label: "Total Leads", value: stats?.totalLeads || 0, icon: "🎯", cls: "qs-purple" },
          { label: "Total Calls", value: stats?.totalCalls || 0, icon: "📞", cls: "qs-green" },
          { label: "Revenue", value: `₹${(stats?.totalRevenue || 0).toLocaleString("en-IN")}`, icon: "💰", cls: "qs-orange" },
        ].map((m, i) => (
          <div key={i} className={`quick-stat ${m.cls}`}>
            <div className="quick-stat-icon">{m.icon}</div>
            <div className="quick-stat-info">
              <div className="quick-stat-label">{m.label}</div>
              <div className="quick-stat-value">{m.value}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Sales Funnel */}
      <div className="funnel-section" style={{ marginBottom: 24 }}>
        <h3>📊 Sales Funnel</h3>
        {[
          { stage: "Total Leads", value: stats?.totalLeads || 0, color: "color-blue" },
          { stage: "Interested", value: stats?.interestedLeads || 0, color: "color-green-light" },
          { stage: "Converted", value: stats?.convertedLeads || 0, color: "color-green" },
        ].map((stage, i) => (
          <div key={i} className="funnel-step">
            <div className="funnel-label">
              <span className="step-name">{stage.stage}</span>
              <span className="step-value">{stage.value}</span>
            </div>
            <div className="funnel-bar">
              <div className={`funnel-bar-fill ${stage.color}`}
                style={{ width: `${stats?.totalLeads ? (stage.value / stats.totalLeads) * 100 : 0}%` }}>
                <span className="fill-percent">
                  {stats?.totalLeads ? Math.round((stage.value / stats.totalLeads) * 100) : 0}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Team Performance */}
      <div className="data-table-wrapper">
        <div className="data-table-toolbar">
          <div className="toolbar-title">
            <h3>👥 Team Performance Overview</h3>
          </div>
        </div>
        <div className="data-table-scroll">
          <table className="data-table">
            <thead>
              <tr>
                <th>Team Member</th>
                <th>Role</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {teamMembers.map((m, i) => (
                <tr key={m.id || i}>
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                      <div className="admin-avatar small">
                        <span>{m.name?.split(" ").map((n) => n[0]).join("")}</span>
                      </div>
                      <span className="font-bold text-14">{m.name}</span>
                    </div>
                  </td>
                  <td>
                    <span className={`status-badge badge-${m.role}`}>{m.role}</span>
                  </td>
                  <td>
                    <span className={`status-badge ${m.isActive !== false ? "badge-completed" : "badge-dead"}`}>
                      {m.isActive !== false ? "Active" : "Inactive"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReportsPage;